(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("._active_17kby_1{background:var(--swan-sem-color-bg-action-active)!important;box-shadow:inset 0 0 0 var(--swan-sem-border-width-action) var(--swan-sem-color-border-action-active)!important;cursor:default!important}")),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
var ns = (t) => {
  throw TypeError(t);
};
var Ct = (t, e, s) => e.has(t) || ns("Cannot " + s);
var n = (t, e, s) => (Ct(t, e, "read from private field"), s ? s.call(t) : e.get(t)), g = (t, e, s) => e.has(t) ? ns("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, s), d = (t, e, s, r) => (Ct(t, e, "write to private field"), r ? r.call(t, s) : e.set(t, s), s), $ = (t, e, s) => (Ct(t, e, "access private method"), s);
var rt = (t, e, s, r) => ({
  set _(i) {
    d(t, e, i, s);
  },
  get _() {
    return n(t, e, r);
  }
});
import { jsx as x, jsxs as ve } from "react/jsx-runtime";
import * as q from "react";
import sr, { createContext as Ht, useState as ye, useRef as xs, useEffect as kt, useCallback as Ds, useMemo as rr, useContext as Gt } from "react";
import { SelectionSetInput as nr, SelectionSetLabel as ir, FlexBox as mt, Typography as He, SelectionSet as or, TextArea as ar, Box as cr, Button as As, Spinner as Ls, Icon as ur, Link as lr } from "@vp/swan";
var ze = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(t) {
    return this.listeners.add(t), this.onSubscribe(), () => {
      this.listeners.delete(t), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, Ee = typeof window > "u" || "Deno" in globalThis;
function H() {
}
function hr(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Mt(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function Is(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function Oe(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Y(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function is(t, e) {
  const {
    type: s = "all",
    exact: r,
    fetchStatus: i,
    predicate: a,
    queryKey: c,
    stale: u
  } = t;
  if (c) {
    if (r) {
      if (e.queryHash !== Jt(c, e.options))
        return !1;
    } else if (!Ge(e.queryKey, c))
      return !1;
  }
  if (s !== "all") {
    const l = e.isActive();
    if (s === "active" && !l || s === "inactive" && l)
      return !1;
  }
  return !(typeof u == "boolean" && e.isStale() !== u || i && i !== e.state.fetchStatus || a && !a(e));
}
function os(t, e) {
  const { exact: s, status: r, predicate: i, mutationKey: a } = t;
  if (a) {
    if (!e.options.mutationKey)
      return !1;
    if (s) {
      if (Pe(e.options.mutationKey) !== Pe(a))
        return !1;
    } else if (!Ge(e.options.mutationKey, a))
      return !1;
  }
  return !(r && e.state.status !== r || i && !i(e));
}
function Jt(t, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || Pe)(t);
}
function Pe(t) {
  return JSON.stringify(
    t,
    (e, s) => Pt(s) ? Object.keys(s).sort().reduce((r, i) => (r[i] = s[i], r), {}) : s
  );
}
function Ge(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? !Object.keys(e).some((s) => !Ge(t[s], e[s])) : !1;
}
function Et(t, e) {
  if (t === e)
    return t;
  const s = as(t) && as(e);
  if (s || Pt(t) && Pt(e)) {
    const r = s ? t : Object.keys(t), i = r.length, a = s ? e : Object.keys(e), c = a.length, u = s ? [] : {};
    let l = 0;
    for (let f = 0; f < c; f++) {
      const h = s ? f : a[f];
      (!s && r.includes(h) || s) && t[h] === void 0 && e[h] === void 0 ? (u[h] = void 0, l++) : (u[h] = Et(t[h], e[h]), u[h] === t[h] && t[h] !== void 0 && l++);
    }
    return i === c && l === i ? t : u;
  }
  return e;
}
function bt(t, e) {
  if (!e || Object.keys(t).length !== Object.keys(e).length)
    return !1;
  for (const s in t)
    if (t[s] !== e[s])
      return !1;
  return !0;
}
function as(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function Pt(t) {
  if (!cs(t))
    return !1;
  const e = t.constructor;
  if (e === void 0)
    return !0;
  const s = e.prototype;
  return !(!cs(s) || !s.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(t) !== Object.prototype);
}
function cs(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function dr(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function Tt(t, e, s) {
  if (typeof s.structuralSharing == "function")
    return s.structuralSharing(t, e);
  if (s.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return Et(t, e);
      } catch (r) {
        console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${s.queryHash}]: ${r}`
        );
      }
    return Et(t, e);
  }
  return e;
}
function fr(t, e, s = 0) {
  const r = [...t, e];
  return s && r.length > s ? r.slice(1) : r;
}
function pr(t, e, s = 0) {
  const r = [e, ...t];
  return s && r.length > s ? r.slice(0, -1) : r;
}
var yt = Symbol();
function Bs(t, e) {
  return process.env.NODE_ENV !== "production" && t.queryFn === yt && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${t.queryHash}'`
  ), !t.queryFn && (e != null && e.initialPromise) ? () => e.initialPromise : !t.queryFn || t.queryFn === yt ? () => Promise.reject(new Error(`Missing queryFn: '${t.queryHash}'`)) : t.queryFn;
}
var ge, ce, xe, Ss, mr = (Ss = class extends ze {
  constructor() {
    super();
    g(this, ge);
    g(this, ce);
    g(this, xe);
    d(this, xe, (e) => {
      if (!Ee && window.addEventListener) {
        const s = () => e();
        return window.addEventListener("visibilitychange", s, !1), () => {
          window.removeEventListener("visibilitychange", s);
        };
      }
    });
  }
  onSubscribe() {
    n(this, ce) || this.setEventListener(n(this, xe));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = n(this, ce)) == null || e.call(this), d(this, ce, void 0));
  }
  setEventListener(e) {
    var s;
    d(this, xe, e), (s = n(this, ce)) == null || s.call(this), d(this, ce, e((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    }));
  }
  setFocused(e) {
    n(this, ge) !== e && (d(this, ge, e), this.onFocus());
  }
  onFocus() {
    const e = this.isFocused();
    this.listeners.forEach((s) => {
      s(e);
    });
  }
  isFocused() {
    var e;
    return typeof n(this, ge) == "boolean" ? n(this, ge) : ((e = globalThis.document) == null ? void 0 : e.visibilityState) !== "hidden";
  }
}, ge = new WeakMap(), ce = new WeakMap(), xe = new WeakMap(), Ss), Wt = new mr(), De, ue, Ae, Cs, br = (Cs = class extends ze {
  constructor() {
    super();
    g(this, De, !0);
    g(this, ue);
    g(this, Ae);
    d(this, Ae, (e) => {
      if (!Ee && window.addEventListener) {
        const s = () => e(!0), r = () => e(!1);
        return window.addEventListener("online", s, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", s), window.removeEventListener("offline", r);
        };
      }
    });
  }
  onSubscribe() {
    n(this, ue) || this.setEventListener(n(this, Ae));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = n(this, ue)) == null || e.call(this), d(this, ue, void 0));
  }
  setEventListener(e) {
    var s;
    d(this, Ae, e), (s = n(this, ue)) == null || s.call(this), d(this, ue, e(this.setOnline.bind(this)));
  }
  setOnline(e) {
    n(this, De) !== e && (d(this, De, e), this.listeners.forEach((r) => {
      r(e);
    }));
  }
  isOnline() {
    return n(this, De);
  }
}, De = new WeakMap(), ue = new WeakMap(), Ae = new WeakMap(), Cs), vt = new br();
function Ot() {
  let t, e;
  const s = new Promise((i, a) => {
    t = i, e = a;
  });
  s.status = "pending", s.catch(() => {
  });
  function r(i) {
    Object.assign(s, i), delete s.resolve, delete s.reject;
  }
  return s.resolve = (i) => {
    r({
      status: "fulfilled",
      value: i
    }), t(i);
  }, s.reject = (i) => {
    r({
      status: "rejected",
      reason: i
    }), e(i);
  }, s;
}
function yr(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function qs(t) {
  return (t ?? "online") === "online" ? vt.isOnline() : !0;
}
var Ns = class extends Error {
  constructor(t) {
    super("CancelledError"), this.revert = t == null ? void 0 : t.revert, this.silent = t == null ? void 0 : t.silent;
  }
};
function $t(t) {
  return t instanceof Ns;
}
function Qs(t) {
  let e = !1, s = 0, r = !1, i;
  const a = Ot(), c = (b) => {
    var p;
    r || (y(new Ns(b)), (p = t.abort) == null || p.call(t));
  }, u = () => {
    e = !0;
  }, l = () => {
    e = !1;
  }, f = () => Wt.isFocused() && (t.networkMode === "always" || vt.isOnline()) && t.canRun(), h = () => qs(t.networkMode) && t.canRun(), o = (b) => {
    var p;
    r || (r = !0, (p = t.onSuccess) == null || p.call(t, b), i == null || i(), a.resolve(b));
  }, y = (b) => {
    var p;
    r || (r = !0, (p = t.onError) == null || p.call(t, b), i == null || i(), a.reject(b));
  }, m = () => new Promise((b) => {
    var p;
    i = (E) => {
      (r || f()) && b(E);
    }, (p = t.onPause) == null || p.call(t);
  }).then(() => {
    var b;
    i = void 0, r || (b = t.onContinue) == null || b.call(t);
  }), R = () => {
    if (r)
      return;
    let b;
    const p = s === 0 ? t.initialPromise : void 0;
    try {
      b = p ?? t.fn();
    } catch (E) {
      b = Promise.reject(E);
    }
    Promise.resolve(b).then(o).catch((E) => {
      var I;
      if (r)
        return;
      const T = t.retry ?? (Ee ? 0 : 3), M = t.retryDelay ?? yr, k = typeof M == "function" ? M(s, E) : M, S = T === !0 || typeof T == "number" && s < T || typeof T == "function" && T(s, E);
      if (e || !S) {
        y(E);
        return;
      }
      s++, (I = t.onFail) == null || I.call(t, s, E), dr(k).then(() => f() ? void 0 : m()).then(() => {
        e ? y(E) : R();
      });
    });
  };
  return {
    promise: a,
    cancel: c,
    continue: () => (i == null || i(), a),
    cancelRetry: u,
    continueRetry: l,
    canStart: h,
    start: () => (h() ? R() : m().then(R), a)
  };
}
function vr() {
  let t = [], e = 0, s = (u) => {
    u();
  }, r = (u) => {
    u();
  }, i = (u) => setTimeout(u, 0);
  const a = (u) => {
    e ? t.push(u) : i(() => {
      s(u);
    });
  }, c = () => {
    const u = t;
    t = [], u.length && i(() => {
      r(() => {
        u.forEach((l) => {
          s(l);
        });
      });
    });
  };
  return {
    batch: (u) => {
      let l;
      e++;
      try {
        l = u();
      } finally {
        e--, e || c();
      }
      return l;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (u) => (...l) => {
      a(() => {
        u(...l);
      });
    },
    schedule: a,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (u) => {
      s = u;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (u) => {
      r = u;
    },
    setScheduler: (u) => {
      i = u;
    }
  };
}
var L = vr(), ke, $s, _s = ($s = class {
  constructor() {
    g(this, ke);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), Mt(this.gcTime) && d(this, ke, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(t) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      t ?? (Ee ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    n(this, ke) && (clearTimeout(n(this, ke)), d(this, ke, void 0));
  }
}, ke = new WeakMap(), $s), Le, Ie, K, we, N, Je, Se, J, se, Rs, gr = (Rs = class extends _s {
  constructor(e) {
    super();
    g(this, J);
    g(this, Le);
    g(this, Ie);
    g(this, K);
    g(this, we);
    g(this, N);
    g(this, Je);
    g(this, Se);
    d(this, Se, !1), d(this, Je, e.defaultOptions), this.setOptions(e.options), this.observers = [], d(this, we, e.client), d(this, K, n(this, we).getQueryCache()), this.queryKey = e.queryKey, this.queryHash = e.queryHash, d(this, Le, kr(this.options)), this.state = e.state ?? n(this, Le), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var e;
    return (e = n(this, N)) == null ? void 0 : e.promise;
  }
  setOptions(e) {
    this.options = { ...n(this, Je), ...e }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && n(this, K).remove(this);
  }
  setData(e, s) {
    const r = Tt(this.state.data, e, this.options);
    return $(this, J, se).call(this, {
      data: r,
      type: "success",
      dataUpdatedAt: s == null ? void 0 : s.updatedAt,
      manual: s == null ? void 0 : s.manual
    }), r;
  }
  setState(e, s) {
    $(this, J, se).call(this, { type: "setState", state: e, setStateOptions: s });
  }
  cancel(e) {
    var r, i;
    const s = (r = n(this, N)) == null ? void 0 : r.promise;
    return (i = n(this, N)) == null || i.cancel(e), s ? s.then(H).catch(H) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(n(this, Le));
  }
  isActive() {
    return this.observers.some(
      (e) => Y(e.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === yt || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (e) => e.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !Is(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var s;
    const e = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    e == null || e.refetch({ cancelRefetch: !1 }), (s = n(this, N)) == null || s.continue();
  }
  onOnline() {
    var s;
    const e = this.observers.find((r) => r.shouldFetchOnReconnect());
    e == null || e.refetch({ cancelRefetch: !1 }), (s = n(this, N)) == null || s.continue();
  }
  addObserver(e) {
    this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), n(this, K).notify({ type: "observerAdded", query: this, observer: e }));
  }
  removeObserver(e) {
    this.observers.includes(e) && (this.observers = this.observers.filter((s) => s !== e), this.observers.length || (n(this, N) && (n(this, Se) ? n(this, N).cancel({ revert: !0 }) : n(this, N).cancelRetry()), this.scheduleGc()), n(this, K).notify({ type: "observerRemoved", query: this, observer: e }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || $(this, J, se).call(this, { type: "invalidate" });
  }
  fetch(e, s) {
    var l, f, h;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (s != null && s.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (n(this, N))
        return n(this, N).continueRetry(), n(this, N).promise;
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const o = this.observers.find((y) => y.options.queryFn);
      o && this.setOptions(o.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const r = new AbortController(), i = (o) => {
      Object.defineProperty(o, "signal", {
        enumerable: !0,
        get: () => (d(this, Se, !0), r.signal)
      });
    }, a = () => {
      const o = Bs(this.options, s), y = {
        client: n(this, we),
        queryKey: this.queryKey,
        meta: this.meta
      };
      return i(y), d(this, Se, !1), this.options.persister ? this.options.persister(
        o,
        y,
        this
      ) : o(y);
    }, c = {
      fetchOptions: s,
      options: this.options,
      queryKey: this.queryKey,
      client: n(this, we),
      state: this.state,
      fetchFn: a
    };
    i(c), (l = this.options.behavior) == null || l.onFetch(
      c,
      this
    ), d(this, Ie, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((f = c.fetchOptions) == null ? void 0 : f.meta)) && $(this, J, se).call(this, { type: "fetch", meta: (h = c.fetchOptions) == null ? void 0 : h.meta });
    const u = (o) => {
      var y, m, R, b;
      $t(o) && o.silent || $(this, J, se).call(this, {
        type: "error",
        error: o
      }), $t(o) || ((m = (y = n(this, K).config).onError) == null || m.call(
        y,
        o,
        this
      ), (b = (R = n(this, K).config).onSettled) == null || b.call(
        R,
        this.state.data,
        o,
        this
      )), this.scheduleGc();
    };
    return d(this, N, Qs({
      initialPromise: s == null ? void 0 : s.initialPromise,
      fn: c.fetchFn,
      abort: r.abort.bind(r),
      onSuccess: (o) => {
        var y, m, R, b;
        if (o === void 0) {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), u(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(o);
        } catch (p) {
          u(p);
          return;
        }
        (m = (y = n(this, K).config).onSuccess) == null || m.call(y, o, this), (b = (R = n(this, K).config).onSettled) == null || b.call(
          R,
          o,
          this.state.error,
          this
        ), this.scheduleGc();
      },
      onError: u,
      onFail: (o, y) => {
        $(this, J, se).call(this, { type: "failed", failureCount: o, error: y });
      },
      onPause: () => {
        $(this, J, se).call(this, { type: "pause" });
      },
      onContinue: () => {
        $(this, J, se).call(this, { type: "continue" });
      },
      retry: c.options.retry,
      retryDelay: c.options.retryDelay,
      networkMode: c.options.networkMode,
      canRun: () => !0
    })), n(this, N).start();
  }
}, Le = new WeakMap(), Ie = new WeakMap(), K = new WeakMap(), we = new WeakMap(), N = new WeakMap(), Je = new WeakMap(), Se = new WeakMap(), J = new WeakSet(), se = function(e) {
  const s = (r) => {
    switch (e.type) {
      case "failed":
        return {
          ...r,
          fetchFailureCount: e.failureCount,
          fetchFailureReason: e.error
        };
      case "pause":
        return {
          ...r,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...r,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...r,
          ...js(r.data, this.options),
          fetchMeta: e.meta ?? null
        };
      case "success":
        return {
          ...r,
          data: e.data,
          dataUpdateCount: r.dataUpdateCount + 1,
          dataUpdatedAt: e.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!e.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const i = e.error;
        return $t(i) && i.revert && n(this, Ie) ? { ...n(this, Ie), fetchStatus: "idle" } : {
          ...r,
          error: i,
          errorUpdateCount: r.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: r.fetchFailureCount + 1,
          fetchFailureReason: i,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...r,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...r,
          ...e.state
        };
    }
  };
  this.state = s(this.state), L.batch(() => {
    this.observers.forEach((r) => {
      r.onQueryUpdate();
    }), n(this, K).notify({ query: this, type: "updated", action: e });
  });
}, Rs);
function js(t, e) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: qs(e.networkMode) ? "fetching" : "paused",
    ...t === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function kr(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, s = e !== void 0, r = s ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: s ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: s ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var Z, Fs, wr = (Fs = class extends ze {
  constructor(e = {}) {
    super();
    g(this, Z);
    this.config = e, d(this, Z, /* @__PURE__ */ new Map());
  }
  build(e, s, r) {
    const i = s.queryKey, a = s.queryHash ?? Jt(i, s);
    let c = this.get(a);
    return c || (c = new gr({
      client: e,
      queryKey: i,
      queryHash: a,
      options: e.defaultQueryOptions(s),
      state: r,
      defaultOptions: e.getQueryDefaults(i)
    }), this.add(c)), c;
  }
  add(e) {
    n(this, Z).has(e.queryHash) || (n(this, Z).set(e.queryHash, e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const s = n(this, Z).get(e.queryHash);
    s && (e.destroy(), s === e && n(this, Z).delete(e.queryHash), this.notify({ type: "removed", query: e }));
  }
  clear() {
    L.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return n(this, Z).get(e);
  }
  getAll() {
    return [...n(this, Z).values()];
  }
  find(e) {
    const s = { exact: !0, ...e };
    return this.getAll().find(
      (r) => is(s, r)
    );
  }
  findAll(e = {}) {
    const s = this.getAll();
    return Object.keys(e).length > 0 ? s.filter((r) => is(e, r)) : s;
  }
  notify(e) {
    L.batch(() => {
      this.listeners.forEach((s) => {
        s(e);
      });
    });
  }
  onFocus() {
    L.batch(() => {
      this.getAll().forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    L.batch(() => {
      this.getAll().forEach((e) => {
        e.onOnline();
      });
    });
  }
}, Z = new WeakMap(), Fs), X, _, Ce, ee, ae, Ms, Sr = (Ms = class extends _s {
  constructor(e) {
    super();
    g(this, ee);
    g(this, X);
    g(this, _);
    g(this, Ce);
    this.mutationId = e.mutationId, d(this, _, e.mutationCache), d(this, X, []), this.state = e.state || Vs(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = e, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(e) {
    n(this, X).includes(e) || (n(this, X).push(e), this.clearGcTimeout(), n(this, _).notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    d(this, X, n(this, X).filter((s) => s !== e)), this.scheduleGc(), n(this, _).notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    n(this, X).length || (this.state.status === "pending" ? this.scheduleGc() : n(this, _).remove(this));
  }
  continue() {
    var e;
    return ((e = n(this, Ce)) == null ? void 0 : e.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(e) {
    var i, a, c, u, l, f, h, o, y, m, R, b, p, E, T, M, k, S, I, D;
    d(this, Ce, Qs({
      fn: () => this.options.mutationFn ? this.options.mutationFn(e) : Promise.reject(new Error("No mutationFn found")),
      onFail: (C, w) => {
        $(this, ee, ae).call(this, { type: "failed", failureCount: C, error: w });
      },
      onPause: () => {
        $(this, ee, ae).call(this, { type: "pause" });
      },
      onContinue: () => {
        $(this, ee, ae).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => n(this, _).canRun(this)
    }));
    const s = this.state.status === "pending", r = !n(this, Ce).canStart();
    try {
      if (!s) {
        $(this, ee, ae).call(this, { type: "pending", variables: e, isPaused: r }), await ((a = (i = n(this, _).config).onMutate) == null ? void 0 : a.call(
          i,
          e,
          this
        ));
        const w = await ((u = (c = this.options).onMutate) == null ? void 0 : u.call(c, e));
        w !== this.state.context && $(this, ee, ae).call(this, {
          type: "pending",
          context: w,
          variables: e,
          isPaused: r
        });
      }
      const C = await n(this, Ce).start();
      return await ((f = (l = n(this, _).config).onSuccess) == null ? void 0 : f.call(
        l,
        C,
        e,
        this.state.context,
        this
      )), await ((o = (h = this.options).onSuccess) == null ? void 0 : o.call(h, C, e, this.state.context)), await ((m = (y = n(this, _).config).onSettled) == null ? void 0 : m.call(
        y,
        C,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((b = (R = this.options).onSettled) == null ? void 0 : b.call(R, C, null, e, this.state.context)), $(this, ee, ae).call(this, { type: "success", data: C }), C;
    } catch (C) {
      try {
        throw await ((E = (p = n(this, _).config).onError) == null ? void 0 : E.call(
          p,
          C,
          e,
          this.state.context,
          this
        )), await ((M = (T = this.options).onError) == null ? void 0 : M.call(
          T,
          C,
          e,
          this.state.context
        )), await ((S = (k = n(this, _).config).onSettled) == null ? void 0 : S.call(
          k,
          void 0,
          C,
          this.state.variables,
          this.state.context,
          this
        )), await ((D = (I = this.options).onSettled) == null ? void 0 : D.call(
          I,
          void 0,
          C,
          e,
          this.state.context
        )), C;
      } finally {
        $(this, ee, ae).call(this, { type: "error", error: C });
      }
    } finally {
      n(this, _).runNext(this);
    }
  }
}, X = new WeakMap(), _ = new WeakMap(), Ce = new WeakMap(), ee = new WeakSet(), ae = function(e) {
  const s = (r) => {
    switch (e.type) {
      case "failed":
        return {
          ...r,
          failureCount: e.failureCount,
          failureReason: e.error
        };
      case "pause":
        return {
          ...r,
          isPaused: !0
        };
      case "continue":
        return {
          ...r,
          isPaused: !1
        };
      case "pending":
        return {
          ...r,
          context: e.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: e.isPaused,
          status: "pending",
          variables: e.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...r,
          data: e.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...r,
          data: void 0,
          error: e.error,
          failureCount: r.failureCount + 1,
          failureReason: e.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = s(this.state), L.batch(() => {
    n(this, X).forEach((r) => {
      r.onMutationUpdate(e);
    }), n(this, _).notify({
      mutation: this,
      type: "updated",
      action: e
    });
  });
}, Ms);
function Vs() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var re, W, We, Es, Cr = (Es = class extends ze {
  constructor(e = {}) {
    super();
    g(this, re);
    g(this, W);
    g(this, We);
    this.config = e, d(this, re, /* @__PURE__ */ new Set()), d(this, W, /* @__PURE__ */ new Map()), d(this, We, 0);
  }
  build(e, s, r) {
    const i = new Sr({
      mutationCache: this,
      mutationId: ++rt(this, We)._,
      options: e.defaultMutationOptions(s),
      state: r
    });
    return this.add(i), i;
  }
  add(e) {
    n(this, re).add(e);
    const s = nt(e);
    if (typeof s == "string") {
      const r = n(this, W).get(s);
      r ? r.push(e) : n(this, W).set(s, [e]);
    }
    this.notify({ type: "added", mutation: e });
  }
  remove(e) {
    if (n(this, re).delete(e)) {
      const s = nt(e);
      if (typeof s == "string") {
        const r = n(this, W).get(s);
        if (r)
          if (r.length > 1) {
            const i = r.indexOf(e);
            i !== -1 && r.splice(i, 1);
          } else r[0] === e && n(this, W).delete(s);
      }
    }
    this.notify({ type: "removed", mutation: e });
  }
  canRun(e) {
    const s = nt(e);
    if (typeof s == "string") {
      const r = n(this, W).get(s), i = r == null ? void 0 : r.find(
        (a) => a.state.status === "pending"
      );
      return !i || i === e;
    } else
      return !0;
  }
  runNext(e) {
    var r;
    const s = nt(e);
    if (typeof s == "string") {
      const i = (r = n(this, W).get(s)) == null ? void 0 : r.find((a) => a !== e && a.state.isPaused);
      return (i == null ? void 0 : i.continue()) ?? Promise.resolve();
    } else
      return Promise.resolve();
  }
  clear() {
    L.batch(() => {
      n(this, re).forEach((e) => {
        this.notify({ type: "removed", mutation: e });
      }), n(this, re).clear(), n(this, W).clear();
    });
  }
  getAll() {
    return Array.from(n(this, re));
  }
  find(e) {
    const s = { exact: !0, ...e };
    return this.getAll().find(
      (r) => os(s, r)
    );
  }
  findAll(e = {}) {
    return this.getAll().filter((s) => os(e, s));
  }
  notify(e) {
    L.batch(() => {
      this.listeners.forEach((s) => {
        s(e);
      });
    });
  }
  resumePausedMutations() {
    const e = this.getAll().filter((s) => s.state.isPaused);
    return L.batch(
      () => Promise.all(
        e.map((s) => s.continue().catch(H))
      )
    );
  }
}, re = new WeakMap(), W = new WeakMap(), We = new WeakMap(), Es);
function nt(t) {
  var e;
  return (e = t.options.scope) == null ? void 0 : e.id;
}
function us(t) {
  return {
    onFetch: (e, s) => {
      var h, o, y, m, R;
      const r = e.options, i = (y = (o = (h = e.fetchOptions) == null ? void 0 : h.meta) == null ? void 0 : o.fetchMore) == null ? void 0 : y.direction, a = ((m = e.state.data) == null ? void 0 : m.pages) || [], c = ((R = e.state.data) == null ? void 0 : R.pageParams) || [];
      let u = { pages: [], pageParams: [] }, l = 0;
      const f = async () => {
        let b = !1;
        const p = (M) => {
          Object.defineProperty(M, "signal", {
            enumerable: !0,
            get: () => (e.signal.aborted ? b = !0 : e.signal.addEventListener("abort", () => {
              b = !0;
            }), e.signal)
          });
        }, E = Bs(e.options, e.fetchOptions), T = async (M, k, S) => {
          if (b)
            return Promise.reject();
          if (k == null && M.pages.length)
            return Promise.resolve(M);
          const I = {
            client: e.client,
            queryKey: e.queryKey,
            pageParam: k,
            direction: S ? "backward" : "forward",
            meta: e.options.meta
          };
          p(I);
          const D = await E(
            I
          ), { maxPages: C } = e.options, w = S ? pr : fr;
          return {
            pages: w(M.pages, D, C),
            pageParams: w(M.pageParams, k, C)
          };
        };
        if (i && a.length) {
          const M = i === "backward", k = M ? $r : ls, S = {
            pages: a,
            pageParams: c
          }, I = k(r, S);
          u = await T(S, I, M);
        } else {
          const M = t ?? a.length;
          do {
            const k = l === 0 ? c[0] ?? r.initialPageParam : ls(r, u);
            if (l > 0 && k == null)
              break;
            u = await T(u, k), l++;
          } while (l < M);
        }
        return u;
      };
      e.options.persister ? e.fetchFn = () => {
        var b, p;
        return (p = (b = e.options).persister) == null ? void 0 : p.call(
          b,
          f,
          {
            client: e.client,
            queryKey: e.queryKey,
            meta: e.options.meta,
            signal: e.signal
          },
          s
        );
      } : e.fetchFn = f;
    }
  };
}
function ls(t, { pages: e, pageParams: s }) {
  const r = e.length - 1;
  return e.length > 0 ? t.getNextPageParam(
    e[r],
    e,
    s[r],
    s
  ) : void 0;
}
function $r(t, { pages: e, pageParams: s }) {
  var r;
  return e.length > 0 ? (r = t.getPreviousPageParam) == null ? void 0 : r.call(t, e[0], e, s[0], s) : void 0;
}
var A, le, he, Be, qe, de, Ne, Qe, Ps, Rr = (Ps = class {
  constructor(t = {}) {
    g(this, A);
    g(this, le);
    g(this, he);
    g(this, Be);
    g(this, qe);
    g(this, de);
    g(this, Ne);
    g(this, Qe);
    d(this, A, t.queryCache || new wr()), d(this, le, t.mutationCache || new Cr()), d(this, he, t.defaultOptions || {}), d(this, Be, /* @__PURE__ */ new Map()), d(this, qe, /* @__PURE__ */ new Map()), d(this, de, 0);
  }
  mount() {
    rt(this, de)._++, n(this, de) === 1 && (d(this, Ne, Wt.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), n(this, A).onFocus());
    })), d(this, Qe, vt.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), n(this, A).onOnline());
    })));
  }
  unmount() {
    var t, e;
    rt(this, de)._--, n(this, de) === 0 && ((t = n(this, Ne)) == null || t.call(this), d(this, Ne, void 0), (e = n(this, Qe)) == null || e.call(this), d(this, Qe, void 0));
  }
  isFetching(t) {
    return n(this, A).findAll({ ...t, fetchStatus: "fetching" }).length;
  }
  isMutating(t) {
    return n(this, le).findAll({ ...t, status: "pending" }).length;
  }
  getQueryData(t) {
    var s;
    const e = this.defaultQueryOptions({ queryKey: t });
    return (s = n(this, A).get(e.queryHash)) == null ? void 0 : s.state.data;
  }
  ensureQueryData(t) {
    const e = this.defaultQueryOptions(t), s = n(this, A).build(this, e), r = s.state.data;
    return r === void 0 ? this.fetchQuery(t) : (t.revalidateIfStale && s.isStaleByTime(Oe(e.staleTime, s)) && this.prefetchQuery(e), Promise.resolve(r));
  }
  getQueriesData(t) {
    return n(this, A).findAll(t).map(({ queryKey: e, state: s }) => {
      const r = s.data;
      return [e, r];
    });
  }
  setQueryData(t, e, s) {
    const r = this.defaultQueryOptions({ queryKey: t }), i = n(this, A).get(
      r.queryHash
    ), a = i == null ? void 0 : i.state.data, c = hr(e, a);
    if (c !== void 0)
      return n(this, A).build(this, r).setData(c, { ...s, manual: !0 });
  }
  setQueriesData(t, e, s) {
    return L.batch(
      () => n(this, A).findAll(t).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, e, s)
      ])
    );
  }
  getQueryState(t) {
    var s;
    const e = this.defaultQueryOptions({ queryKey: t });
    return (s = n(this, A).get(
      e.queryHash
    )) == null ? void 0 : s.state;
  }
  removeQueries(t) {
    const e = n(this, A);
    L.batch(() => {
      e.findAll(t).forEach((s) => {
        e.remove(s);
      });
    });
  }
  resetQueries(t, e) {
    const s = n(this, A), r = {
      type: "active",
      ...t
    };
    return L.batch(() => (s.findAll(t).forEach((i) => {
      i.reset();
    }), this.refetchQueries(r, e)));
  }
  cancelQueries(t, e = {}) {
    const s = { revert: !0, ...e }, r = L.batch(
      () => n(this, A).findAll(t).map((i) => i.cancel(s))
    );
    return Promise.all(r).then(H).catch(H);
  }
  invalidateQueries(t, e = {}) {
    return L.batch(() => {
      if (n(this, A).findAll(t).forEach((r) => {
        r.invalidate();
      }), (t == null ? void 0 : t.refetchType) === "none")
        return Promise.resolve();
      const s = {
        ...t,
        type: (t == null ? void 0 : t.refetchType) ?? (t == null ? void 0 : t.type) ?? "active"
      };
      return this.refetchQueries(s, e);
    });
  }
  refetchQueries(t, e = {}) {
    const s = {
      ...e,
      cancelRefetch: e.cancelRefetch ?? !0
    }, r = L.batch(
      () => n(this, A).findAll(t).filter((i) => !i.isDisabled()).map((i) => {
        let a = i.fetch(void 0, s);
        return s.throwOnError || (a = a.catch(H)), i.state.fetchStatus === "paused" ? Promise.resolve() : a;
      })
    );
    return Promise.all(r).then(H);
  }
  fetchQuery(t) {
    const e = this.defaultQueryOptions(t);
    e.retry === void 0 && (e.retry = !1);
    const s = n(this, A).build(this, e);
    return s.isStaleByTime(
      Oe(e.staleTime, s)
    ) ? s.fetch(e) : Promise.resolve(s.state.data);
  }
  prefetchQuery(t) {
    return this.fetchQuery(t).then(H).catch(H);
  }
  fetchInfiniteQuery(t) {
    return t.behavior = us(t.pages), this.fetchQuery(t);
  }
  prefetchInfiniteQuery(t) {
    return this.fetchInfiniteQuery(t).then(H).catch(H);
  }
  ensureInfiniteQueryData(t) {
    return t.behavior = us(t.pages), this.ensureQueryData(t);
  }
  resumePausedMutations() {
    return vt.isOnline() ? n(this, le).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return n(this, A);
  }
  getMutationCache() {
    return n(this, le);
  }
  getDefaultOptions() {
    return n(this, he);
  }
  setDefaultOptions(t) {
    d(this, he, t);
  }
  setQueryDefaults(t, e) {
    n(this, Be).set(Pe(t), {
      queryKey: t,
      defaultOptions: e
    });
  }
  getQueryDefaults(t) {
    const e = [...n(this, Be).values()], s = {};
    return e.forEach((r) => {
      Ge(t, r.queryKey) && Object.assign(s, r.defaultOptions);
    }), s;
  }
  setMutationDefaults(t, e) {
    n(this, qe).set(Pe(t), {
      mutationKey: t,
      defaultOptions: e
    });
  }
  getMutationDefaults(t) {
    const e = [...n(this, qe).values()];
    let s = {};
    return e.forEach((r) => {
      Ge(t, r.mutationKey) && (s = { ...s, ...r.defaultOptions });
    }), s;
  }
  defaultQueryOptions(t) {
    if (t._defaulted)
      return t;
    const e = {
      ...n(this, he).queries,
      ...this.getQueryDefaults(t.queryKey),
      ...t,
      _defaulted: !0
    };
    return e.queryHash || (e.queryHash = Jt(
      e.queryKey,
      e
    )), e.refetchOnReconnect === void 0 && (e.refetchOnReconnect = e.networkMode !== "always"), e.throwOnError === void 0 && (e.throwOnError = !!e.suspense), !e.networkMode && e.persister && (e.networkMode = "offlineFirst"), e.queryFn === yt && (e.enabled = !1), e;
  }
  defaultMutationOptions(t) {
    return t != null && t._defaulted ? t : {
      ...n(this, he).mutations,
      ...(t == null ? void 0 : t.mutationKey) && this.getMutationDefaults(t.mutationKey),
      ...t,
      _defaulted: !0
    };
  }
  clear() {
    n(this, A).clear(), n(this, le).clear();
  }
}, A = new WeakMap(), le = new WeakMap(), he = new WeakMap(), Be = new WeakMap(), qe = new WeakMap(), de = new WeakMap(), Ne = new WeakMap(), Qe = new WeakMap(), Ps), V, F, Ye, j, $e, _e, fe, te, Ze, je, Ve, Re, Fe, pe, Ue, P, Ke, xt, Dt, At, Lt, It, Bt, qt, Us, Ts, Fr = (Ts = class extends ze {
  constructor(e, s) {
    super();
    g(this, P);
    g(this, V);
    g(this, F);
    g(this, Ye);
    g(this, j);
    g(this, $e);
    g(this, _e);
    g(this, fe);
    g(this, te);
    g(this, Ze);
    g(this, je);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    g(this, Ve);
    g(this, Re);
    g(this, Fe);
    g(this, pe);
    g(this, Ue, /* @__PURE__ */ new Set());
    this.options = s, d(this, V, e), d(this, te, null), d(this, fe, Ot()), this.options.experimental_prefetchInRender || n(this, fe).reject(
      new Error("experimental_prefetchInRender feature flag is not enabled")
    ), this.bindMethods(), this.setOptions(s);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (n(this, F).addObserver(this), hs(n(this, F), this.options) ? $(this, P, Ke).call(this) : this.updateResult(), $(this, P, Lt).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return Nt(
      n(this, F),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return Nt(
      n(this, F),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), $(this, P, It).call(this), $(this, P, Bt).call(this), n(this, F).removeObserver(this);
  }
  setOptions(e, s) {
    const r = this.options, i = n(this, F);
    if (this.options = n(this, V).defaultQueryOptions(e), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof Y(this.options.enabled, n(this, F)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    $(this, P, qt).call(this), n(this, F).setOptions(this.options), r._defaulted && !bt(this.options, r) && n(this, V).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: n(this, F),
      observer: this
    });
    const a = this.hasListeners();
    a && ds(
      n(this, F),
      i,
      this.options,
      r
    ) && $(this, P, Ke).call(this), this.updateResult(s), a && (n(this, F) !== i || Y(this.options.enabled, n(this, F)) !== Y(r.enabled, n(this, F)) || Oe(this.options.staleTime, n(this, F)) !== Oe(r.staleTime, n(this, F))) && $(this, P, xt).call(this);
    const c = $(this, P, Dt).call(this);
    a && (n(this, F) !== i || Y(this.options.enabled, n(this, F)) !== Y(r.enabled, n(this, F)) || c !== n(this, pe)) && $(this, P, At).call(this, c);
  }
  getOptimisticResult(e) {
    const s = n(this, V).getQueryCache().build(n(this, V), e), r = this.createResult(s, e);
    return Er(this, r) && (d(this, j, r), d(this, _e, this.options), d(this, $e, n(this, F).state)), r;
  }
  getCurrentResult() {
    return n(this, j);
  }
  trackResult(e, s) {
    const r = {};
    return Object.keys(e).forEach((i) => {
      Object.defineProperty(r, i, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackProp(i), s == null || s(i), e[i])
      });
    }), r;
  }
  trackProp(e) {
    n(this, Ue).add(e);
  }
  getCurrentQuery() {
    return n(this, F);
  }
  refetch({ ...e } = {}) {
    return this.fetch({
      ...e
    });
  }
  fetchOptimistic(e) {
    const s = n(this, V).defaultQueryOptions(e), r = n(this, V).getQueryCache().build(n(this, V), s);
    return r.fetch().then(() => this.createResult(r, s));
  }
  fetch(e) {
    return $(this, P, Ke).call(this, {
      ...e,
      cancelRefetch: e.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), n(this, j)));
  }
  createResult(e, s) {
    var C;
    const r = n(this, F), i = this.options, a = n(this, j), c = n(this, $e), u = n(this, _e), f = e !== r ? e.state : n(this, Ye), { state: h } = e;
    let o = { ...h }, y = !1, m;
    if (s._optimisticResults) {
      const w = this.hasListeners(), Q = !w && hs(e, s), G = w && ds(e, r, s, i);
      (Q || G) && (o = {
        ...o,
        ...js(h.data, e.options)
      }), s._optimisticResults === "isRestoring" && (o.fetchStatus = "idle");
    }
    let { error: R, errorUpdatedAt: b, status: p } = o;
    if (s.select && o.data !== void 0)
      if (a && o.data === (c == null ? void 0 : c.data) && s.select === n(this, Ze))
        m = n(this, je);
      else
        try {
          d(this, Ze, s.select), m = s.select(o.data), m = Tt(a == null ? void 0 : a.data, m, s), d(this, je, m), d(this, te, null);
        } catch (w) {
          d(this, te, w);
        }
    else
      m = o.data;
    if (s.placeholderData !== void 0 && m === void 0 && p === "pending") {
      let w;
      if (a != null && a.isPlaceholderData && s.placeholderData === (u == null ? void 0 : u.placeholderData))
        w = a.data;
      else if (w = typeof s.placeholderData == "function" ? s.placeholderData(
        (C = n(this, Ve)) == null ? void 0 : C.state.data,
        n(this, Ve)
      ) : s.placeholderData, s.select && w !== void 0)
        try {
          w = s.select(w), d(this, te, null);
        } catch (Q) {
          d(this, te, Q);
        }
      w !== void 0 && (p = "success", m = Tt(
        a == null ? void 0 : a.data,
        w,
        s
      ), y = !0);
    }
    n(this, te) && (R = n(this, te), m = n(this, je), b = Date.now(), p = "error");
    const E = o.fetchStatus === "fetching", T = p === "pending", M = p === "error", k = T && E, S = m !== void 0, D = {
      status: p,
      fetchStatus: o.fetchStatus,
      isPending: T,
      isSuccess: p === "success",
      isError: M,
      isInitialLoading: k,
      isLoading: k,
      data: m,
      dataUpdatedAt: o.dataUpdatedAt,
      error: R,
      errorUpdatedAt: b,
      failureCount: o.fetchFailureCount,
      failureReason: o.fetchFailureReason,
      errorUpdateCount: o.errorUpdateCount,
      isFetched: o.dataUpdateCount > 0 || o.errorUpdateCount > 0,
      isFetchedAfterMount: o.dataUpdateCount > f.dataUpdateCount || o.errorUpdateCount > f.errorUpdateCount,
      isFetching: E,
      isRefetching: E && !T,
      isLoadingError: M && !S,
      isPaused: o.fetchStatus === "paused",
      isPlaceholderData: y,
      isRefetchError: M && S,
      isStale: Yt(e, s),
      refetch: this.refetch,
      promise: n(this, fe)
    };
    if (this.options.experimental_prefetchInRender) {
      const w = (oe) => {
        D.status === "error" ? oe.reject(D.error) : D.data !== void 0 && oe.resolve(D.data);
      }, Q = () => {
        const oe = d(this, fe, D.promise = Ot());
        w(oe);
      }, G = n(this, fe);
      switch (G.status) {
        case "pending":
          e.queryHash === r.queryHash && w(G);
          break;
        case "fulfilled":
          (D.status === "error" || D.data !== G.value) && Q();
          break;
        case "rejected":
          (D.status !== "error" || D.error !== G.reason) && Q();
          break;
      }
    }
    return D;
  }
  updateResult(e) {
    const s = n(this, j), r = this.createResult(n(this, F), this.options);
    if (d(this, $e, n(this, F).state), d(this, _e, this.options), n(this, $e).data !== void 0 && d(this, Ve, n(this, F)), bt(r, s))
      return;
    d(this, j, r);
    const i = {}, a = () => {
      if (!s)
        return !0;
      const { notifyOnChangeProps: c } = this.options, u = typeof c == "function" ? c() : c;
      if (u === "all" || !u && !n(this, Ue).size)
        return !0;
      const l = new Set(
        u ?? n(this, Ue)
      );
      return this.options.throwOnError && l.add("error"), Object.keys(n(this, j)).some((f) => {
        const h = f;
        return n(this, j)[h] !== s[h] && l.has(h);
      });
    };
    (e == null ? void 0 : e.listeners) !== !1 && a() && (i.listeners = !0), $(this, P, Us).call(this, { ...i, ...e });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && $(this, P, Lt).call(this);
  }
}, V = new WeakMap(), F = new WeakMap(), Ye = new WeakMap(), j = new WeakMap(), $e = new WeakMap(), _e = new WeakMap(), fe = new WeakMap(), te = new WeakMap(), Ze = new WeakMap(), je = new WeakMap(), Ve = new WeakMap(), Re = new WeakMap(), Fe = new WeakMap(), pe = new WeakMap(), Ue = new WeakMap(), P = new WeakSet(), Ke = function(e) {
  $(this, P, qt).call(this);
  let s = n(this, F).fetch(
    this.options,
    e
  );
  return e != null && e.throwOnError || (s = s.catch(H)), s;
}, xt = function() {
  $(this, P, It).call(this);
  const e = Oe(
    this.options.staleTime,
    n(this, F)
  );
  if (Ee || n(this, j).isStale || !Mt(e))
    return;
  const r = Is(n(this, j).dataUpdatedAt, e) + 1;
  d(this, Re, setTimeout(() => {
    n(this, j).isStale || this.updateResult();
  }, r));
}, Dt = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(n(this, F)) : this.options.refetchInterval) ?? !1;
}, At = function(e) {
  $(this, P, Bt).call(this), d(this, pe, e), !(Ee || Y(this.options.enabled, n(this, F)) === !1 || !Mt(n(this, pe)) || n(this, pe) === 0) && d(this, Fe, setInterval(() => {
    (this.options.refetchIntervalInBackground || Wt.isFocused()) && $(this, P, Ke).call(this);
  }, n(this, pe)));
}, Lt = function() {
  $(this, P, xt).call(this), $(this, P, At).call(this, $(this, P, Dt).call(this));
}, It = function() {
  n(this, Re) && (clearTimeout(n(this, Re)), d(this, Re, void 0));
}, Bt = function() {
  n(this, Fe) && (clearInterval(n(this, Fe)), d(this, Fe, void 0));
}, qt = function() {
  const e = n(this, V).getQueryCache().build(n(this, V), this.options);
  if (e === n(this, F))
    return;
  const s = n(this, F);
  d(this, F, e), d(this, Ye, e.state), this.hasListeners() && (s == null || s.removeObserver(this), e.addObserver(this));
}, Us = function(e) {
  L.batch(() => {
    e.listeners && this.listeners.forEach((s) => {
      s(n(this, j));
    }), n(this, V).getQueryCache().notify({
      query: n(this, F),
      type: "observerResultsUpdated"
    });
  });
}, Ts);
function Mr(t, e) {
  return Y(e.enabled, t) !== !1 && t.state.data === void 0 && !(t.state.status === "error" && e.retryOnMount === !1);
}
function hs(t, e) {
  return Mr(t, e) || t.state.data !== void 0 && Nt(t, e, e.refetchOnMount);
}
function Nt(t, e, s) {
  if (Y(e.enabled, t) !== !1) {
    const r = typeof s == "function" ? s(t) : s;
    return r === "always" || r !== !1 && Yt(t, e);
  }
  return !1;
}
function ds(t, e, s, r) {
  return (t !== e || Y(r.enabled, t) === !1) && (!s.suspense || t.state.status !== "error") && Yt(t, s);
}
function Yt(t, e) {
  return Y(e.enabled, t) !== !1 && t.isStaleByTime(Oe(e.staleTime, t));
}
function Er(t, e) {
  return !bt(t.getCurrentResult(), e);
}
var me, be, U, ne, ie, it, Qt, Os, Pr = (Os = class extends ze {
  constructor(e, s) {
    super();
    g(this, ie);
    g(this, me);
    g(this, be);
    g(this, U);
    g(this, ne);
    d(this, me, e), this.setOptions(s), this.bindMethods(), $(this, ie, it).call(this);
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(e) {
    var r;
    const s = this.options;
    this.options = n(this, me).defaultMutationOptions(e), bt(this.options, s) || n(this, me).getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: n(this, U),
      observer: this
    }), s != null && s.mutationKey && this.options.mutationKey && Pe(s.mutationKey) !== Pe(this.options.mutationKey) ? this.reset() : ((r = n(this, U)) == null ? void 0 : r.state.status) === "pending" && n(this, U).setOptions(this.options);
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || (e = n(this, U)) == null || e.removeObserver(this);
  }
  onMutationUpdate(e) {
    $(this, ie, it).call(this), $(this, ie, Qt).call(this, e);
  }
  getCurrentResult() {
    return n(this, be);
  }
  reset() {
    var e;
    (e = n(this, U)) == null || e.removeObserver(this), d(this, U, void 0), $(this, ie, it).call(this), $(this, ie, Qt).call(this);
  }
  mutate(e, s) {
    var r;
    return d(this, ne, s), (r = n(this, U)) == null || r.removeObserver(this), d(this, U, n(this, me).getMutationCache().build(n(this, me), this.options)), n(this, U).addObserver(this), n(this, U).execute(e);
  }
}, me = new WeakMap(), be = new WeakMap(), U = new WeakMap(), ne = new WeakMap(), ie = new WeakSet(), it = function() {
  var s;
  const e = ((s = n(this, U)) == null ? void 0 : s.state) ?? Vs();
  d(this, be, {
    ...e,
    isPending: e.status === "pending",
    isSuccess: e.status === "success",
    isError: e.status === "error",
    isIdle: e.status === "idle",
    mutate: this.mutate,
    reset: this.reset
  });
}, Qt = function(e) {
  L.batch(() => {
    var s, r, i, a, c, u, l, f;
    if (n(this, ne) && this.hasListeners()) {
      const h = n(this, be).variables, o = n(this, be).context;
      (e == null ? void 0 : e.type) === "success" ? ((r = (s = n(this, ne)).onSuccess) == null || r.call(s, e.data, h, o), (a = (i = n(this, ne)).onSettled) == null || a.call(i, e.data, null, h, o)) : (e == null ? void 0 : e.type) === "error" && ((u = (c = n(this, ne)).onError) == null || u.call(c, e.error, h, o), (f = (l = n(this, ne)).onSettled) == null || f.call(
        l,
        void 0,
        e.error,
        h,
        o
      ));
    }
    this.listeners.forEach((h) => {
      h(n(this, be));
    });
  });
}, Os), zs = q.createContext(
  void 0
), Ks = (t) => {
  const e = q.useContext(zs);
  if (!e)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
}, Tr = ({
  client: t,
  children: e
}) => (q.useEffect(() => (t.mount(), () => {
  t.unmount();
}), [t]), /* @__PURE__ */ x(zs.Provider, { value: t, children: e })), Hs = q.createContext(!1), Or = () => q.useContext(Hs);
Hs.Provider;
function xr() {
  let t = !1;
  return {
    clearReset: () => {
      t = !1;
    },
    reset: () => {
      t = !0;
    },
    isReset: () => t
  };
}
var Dr = q.createContext(xr()), Ar = () => q.useContext(Dr);
function Gs(t, e) {
  return typeof t == "function" ? t(...e) : !!t;
}
function _t() {
}
var Lr = (t, e) => {
  (t.suspense || t.throwOnError || t.experimental_prefetchInRender) && (e.isReset() || (t.retryOnMount = !1));
}, Ir = (t) => {
  q.useEffect(() => {
    t.clearReset();
  }, [t]);
}, Br = ({
  result: t,
  errorResetBoundary: e,
  throwOnError: s,
  query: r,
  suspense: i
}) => t.isError && !e.isReset() && !t.isFetching && r && (i && t.data === void 0 || Gs(s, [t.error, r])), qr = (t) => {
  const e = t.staleTime;
  t.suspense && (t.staleTime = typeof e == "function" ? (...s) => Math.max(e(...s), 1e3) : Math.max(e ?? 1e3, 1e3), typeof t.gcTime == "number" && (t.gcTime = Math.max(t.gcTime, 1e3)));
}, Nr = (t, e) => t.isLoading && t.isFetching && !e, Qr = (t, e) => (t == null ? void 0 : t.suspense) && e.isPending, fs = (t, e, s) => e.fetchOptimistic(t).catch(() => {
  s.clearReset();
});
function _r(t, e, s) {
  var o, y, m, R, b;
  if (process.env.NODE_ENV !== "production" && (typeof t != "object" || Array.isArray(t)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const r = Ks(), i = Or(), a = Ar(), c = r.defaultQueryOptions(t);
  (y = (o = r.getDefaultOptions().queries) == null ? void 0 : o._experimental_beforeQuery) == null || y.call(
    o,
    c
  ), c._optimisticResults = i ? "isRestoring" : "optimistic", qr(c), Lr(c, a), Ir(a);
  const u = !r.getQueryCache().get(c.queryHash), [l] = q.useState(
    () => new e(
      r,
      c
    )
  ), f = l.getOptimisticResult(c), h = !i && t.subscribed !== !1;
  if (q.useSyncExternalStore(
    q.useCallback(
      (p) => {
        const E = h ? l.subscribe(L.batchCalls(p)) : _t;
        return l.updateResult(), E;
      },
      [l, h]
    ),
    () => l.getCurrentResult(),
    () => l.getCurrentResult()
  ), q.useEffect(() => {
    l.setOptions(c, { listeners: !1 });
  }, [c, l]), Qr(c, f))
    throw fs(c, l, a);
  if (Br({
    result: f,
    errorResetBoundary: a,
    throwOnError: c.throwOnError,
    query: r.getQueryCache().get(c.queryHash),
    suspense: c.suspense
  }))
    throw f.error;
  if ((R = (m = r.getDefaultOptions().queries) == null ? void 0 : m._experimental_afterQuery) == null || R.call(
    m,
    c,
    f
  ), c.experimental_prefetchInRender && !Ee && Nr(f, i)) {
    const p = u ? (
      // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
      fs(c, l, a)
    ) : (
      // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
      (b = r.getQueryCache().get(c.queryHash)) == null ? void 0 : b.promise
    );
    p == null || p.catch(_t).finally(() => {
      l.updateResult();
    });
  }
  return c.notifyOnChangeProps ? f : l.trackResult(f);
}
function jr(t, e) {
  return _r(t, Fr);
}
function Js(t, e) {
  const s = Ks(), [r] = q.useState(
    () => new Pr(
      s,
      t
    )
  );
  q.useEffect(() => {
    r.setOptions(t);
  }, [r, t]);
  const i = q.useSyncExternalStore(
    q.useCallback(
      (c) => r.subscribe(L.batchCalls(c)),
      [r]
    ),
    () => r.getCurrentResult(),
    () => r.getCurrentResult()
  ), a = q.useCallback(
    (c, u) => {
      r.mutate(c, u).catch(_t);
    },
    [r]
  );
  if (i.error && Gs(r.options.throwOnError, [i.error]))
    throw i.error;
  return { ...i, mutate: a, mutateAsync: i.mutate };
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var jt = function() {
  return jt = Object.assign || function(t) {
    for (var e, s = 1, r = arguments.length; s < r; s++) for (var i in e = arguments[s]) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    return t;
  }, jt.apply(this, arguments);
}, Vt, Vr = function(t) {
  var e;
  t ? function(s) {
    if (s) for (; s.lastChild; ) s.lastChild.remove();
  }(typeof t == "string" ? document.getElementById(t) : t) : (e = document.querySelector(".grecaptcha-badge")) && e.parentNode && document.body.removeChild(e.parentNode);
}, Ur = function(t, e) {
  Vr(e), window.___grecaptcha_cfg = void 0;
  var s = document.querySelector("#" + t);
  s && s.remove(), function() {
    var r = document.querySelector('script[src^="https://www.gstatic.com/recaptcha/releases"]');
    r && r.remove();
  }();
}, zr = function(t) {
  var e = t.render, s = t.onLoadCallbackName, r = t.language, i = t.onLoad, a = t.useRecaptchaNet, c = t.useEnterprise, u = t.scriptProps, l = u === void 0 ? {} : u, f = l.nonce, h = f === void 0 ? "" : f, o = l.defer, y = o !== void 0 && o, m = l.async, R = m !== void 0 && m, b = l.id, p = b === void 0 ? "" : b, E = l.appendTo, T = p || "google-recaptcha-v3";
  if (function(S) {
    return !!document.querySelector("#" + S);
  }(T)) i();
  else {
    var M = function(S) {
      return "https://www." + (S.useRecaptchaNet ? "recaptcha.net" : "google.com") + "/recaptcha/" + (S.useEnterprise ? "enterprise.js" : "api.js");
    }({ useEnterprise: c, useRecaptchaNet: a }), k = document.createElement("script");
    k.id = T, k.src = M + "?render=" + e + (e === "explicit" ? "&onload=" + s : "") + (r ? "&hl=" + r : ""), h && (k.nonce = h), k.defer = !!y, k.async = !!R, k.onload = i, (E === "body" ? document.body : document.getElementsByTagName("head")[0]).appendChild(k);
  }
}, ps = function(t) {
  typeof process < "u" && process.env && process.env.NODE_ENV !== "production" || console.warn(t);
};
(function(t) {
  t.SCRIPT_NOT_AVAILABLE = "Recaptcha script is not available";
})(Vt || (Vt = {}));
var Zt = Ht({ executeRecaptcha: function() {
  throw Error("GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider");
} });
Zt.Consumer;
function Kr(t) {
  var e = t.reCaptchaKey, s = t.useEnterprise, r = s !== void 0 && s, i = t.useRecaptchaNet, a = i !== void 0 && i, c = t.scriptProps, u = t.language, l = t.container, f = t.children, h = ye(null), o = h[0], y = h[1], m = xs(e), R = JSON.stringify(c), b = JSON.stringify(l == null ? void 0 : l.parameters);
  kt(function() {
    if (e) {
      var T = (c == null ? void 0 : c.id) || "google-recaptcha-v3", M = (c == null ? void 0 : c.onLoadCallbackName) || "onRecaptchaLoadCallback";
      return window[M] = function() {
        var k = r ? window.grecaptcha.enterprise : window.grecaptcha, S = jt({ badge: "inline", size: "invisible", sitekey: e }, (l == null ? void 0 : l.parameters) || {});
        m.current = k.render(l == null ? void 0 : l.element, S);
      }, zr({ render: l != null && l.element ? "explicit" : e, onLoadCallbackName: M, useEnterprise: r, useRecaptchaNet: a, scriptProps: c, language: u, onLoad: function() {
        if (window && window.grecaptcha) {
          var k = r ? window.grecaptcha.enterprise : window.grecaptcha;
          k.ready(function() {
            y(k);
          });
        } else ps("<GoogleRecaptchaProvider /> " + Vt.SCRIPT_NOT_AVAILABLE);
      } }), function() {
        Ur(T, l == null ? void 0 : l.element);
      };
    }
    ps("<GoogleReCaptchaProvider /> recaptcha key not provided");
  }, [r, a, R, b, u, e, l == null ? void 0 : l.element]);
  var p = Ds(function(T) {
    if (!o || !o.execute) throw new Error("<GoogleReCaptchaProvider /> Google Recaptcha has not been loaded");
    return o.execute(m.current, { action: T });
  }, [o, m]), E = rr(function() {
    return { executeRecaptcha: o ? p : void 0, container: l == null ? void 0 : l.element };
  }, [p, o, l == null ? void 0 : l.element]);
  return sr.createElement(Zt.Provider, { value: E }, f);
}
var Hr = function() {
  return Gt(Zt);
};
function Ws(t, e) {
  return t(e = { exports: {} }, e.exports), e.exports;
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
}
var B = typeof Symbol == "function" && Symbol.for, Ut = B ? Symbol.for("react.element") : 60103, zt = B ? Symbol.for("react.portal") : 60106, ot = B ? Symbol.for("react.fragment") : 60107, at = B ? Symbol.for("react.strict_mode") : 60108, ct = B ? Symbol.for("react.profiler") : 60114, ut = B ? Symbol.for("react.provider") : 60109, lt = B ? Symbol.for("react.context") : 60110, Kt = B ? Symbol.for("react.async_mode") : 60111, gt = B ? Symbol.for("react.concurrent_mode") : 60111, ht = B ? Symbol.for("react.forward_ref") : 60112, dt = B ? Symbol.for("react.suspense") : 60113, Gr = B ? Symbol.for("react.suspense_list") : 60120, ft = B ? Symbol.for("react.memo") : 60115, pt = B ? Symbol.for("react.lazy") : 60116, Jr = B ? Symbol.for("react.block") : 60121, Wr = B ? Symbol.for("react.fundamental") : 60117, Yr = B ? Symbol.for("react.responder") : 60118, Zr = B ? Symbol.for("react.scope") : 60119;
function z(t) {
  if (typeof t == "object" && t !== null) {
    var e = t.$$typeof;
    switch (e) {
      case Ut:
        switch (t = t.type) {
          case Kt:
          case gt:
          case ot:
          case ct:
          case at:
          case dt:
            return t;
          default:
            switch (t = t && t.$$typeof) {
              case lt:
              case ht:
              case pt:
              case ft:
              case ut:
                return t;
              default:
                return e;
            }
        }
      case zt:
        return e;
    }
  }
}
function ms(t) {
  return z(t) === gt;
}
var Xr = { AsyncMode: Kt, ConcurrentMode: gt, ContextConsumer: lt, ContextProvider: ut, Element: Ut, ForwardRef: ht, Fragment: ot, Lazy: pt, Memo: ft, Portal: zt, Profiler: ct, StrictMode: at, Suspense: dt, isAsyncMode: function(t) {
  return ms(t) || z(t) === Kt;
}, isConcurrentMode: ms, isContextConsumer: function(t) {
  return z(t) === lt;
}, isContextProvider: function(t) {
  return z(t) === ut;
}, isElement: function(t) {
  return typeof t == "object" && t !== null && t.$$typeof === Ut;
}, isForwardRef: function(t) {
  return z(t) === ht;
}, isFragment: function(t) {
  return z(t) === ot;
}, isLazy: function(t) {
  return z(t) === pt;
}, isMemo: function(t) {
  return z(t) === ft;
}, isPortal: function(t) {
  return z(t) === zt;
}, isProfiler: function(t) {
  return z(t) === ct;
}, isStrictMode: function(t) {
  return z(t) === at;
}, isSuspense: function(t) {
  return z(t) === dt;
}, isValidElementType: function(t) {
  return typeof t == "string" || typeof t == "function" || t === ot || t === gt || t === ct || t === at || t === dt || t === Gr || typeof t == "object" && t !== null && (t.$$typeof === pt || t.$$typeof === ft || t.$$typeof === ut || t.$$typeof === lt || t.$$typeof === ht || t.$$typeof === Wr || t.$$typeof === Yr || t.$$typeof === Zr || t.$$typeof === Jr);
}, typeOf: z }, O = Ws(function(t, e) {
  process.env.NODE_ENV !== "production" && function() {
    var s = typeof Symbol == "function" && Symbol.for, r = s ? Symbol.for("react.element") : 60103, i = s ? Symbol.for("react.portal") : 60106, a = s ? Symbol.for("react.fragment") : 60107, c = s ? Symbol.for("react.strict_mode") : 60108, u = s ? Symbol.for("react.profiler") : 60114, l = s ? Symbol.for("react.provider") : 60109, f = s ? Symbol.for("react.context") : 60110, h = s ? Symbol.for("react.async_mode") : 60111, o = s ? Symbol.for("react.concurrent_mode") : 60111, y = s ? Symbol.for("react.forward_ref") : 60112, m = s ? Symbol.for("react.suspense") : 60113, R = s ? Symbol.for("react.suspense_list") : 60120, b = s ? Symbol.for("react.memo") : 60115, p = s ? Symbol.for("react.lazy") : 60116, E = s ? Symbol.for("react.block") : 60121, T = s ? Symbol.for("react.fundamental") : 60117, M = s ? Symbol.for("react.responder") : 60118, k = s ? Symbol.for("react.scope") : 60119;
    function S(v) {
      if (typeof v == "object" && v !== null) {
        var St = v.$$typeof;
        switch (St) {
          case r:
            var st = v.type;
            switch (st) {
              case h:
              case o:
              case a:
              case u:
              case c:
              case m:
                return st;
              default:
                var rs = st && st.$$typeof;
                switch (rs) {
                  case f:
                  case y:
                  case p:
                  case b:
                  case l:
                    return rs;
                  default:
                    return St;
                }
            }
          case i:
            return St;
        }
      }
    }
    var I = h, D = o, C = f, w = l, Q = r, G = y, oe = a, wt = p, Xe = b, et = i, tt = u, er = c, tr = m, ts = !1;
    function ss(v) {
      return S(v) === o;
    }
    e.AsyncMode = I, e.ConcurrentMode = D, e.ContextConsumer = C, e.ContextProvider = w, e.Element = Q, e.ForwardRef = G, e.Fragment = oe, e.Lazy = wt, e.Memo = Xe, e.Portal = et, e.Profiler = tt, e.StrictMode = er, e.Suspense = tr, e.isAsyncMode = function(v) {
      return ts || (ts = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ss(v) || S(v) === h;
    }, e.isConcurrentMode = ss, e.isContextConsumer = function(v) {
      return S(v) === f;
    }, e.isContextProvider = function(v) {
      return S(v) === l;
    }, e.isElement = function(v) {
      return typeof v == "object" && v !== null && v.$$typeof === r;
    }, e.isForwardRef = function(v) {
      return S(v) === y;
    }, e.isFragment = function(v) {
      return S(v) === a;
    }, e.isLazy = function(v) {
      return S(v) === p;
    }, e.isMemo = function(v) {
      return S(v) === b;
    }, e.isPortal = function(v) {
      return S(v) === i;
    }, e.isProfiler = function(v) {
      return S(v) === u;
    }, e.isStrictMode = function(v) {
      return S(v) === c;
    }, e.isSuspense = function(v) {
      return S(v) === m;
    }, e.isValidElementType = function(v) {
      return typeof v == "string" || typeof v == "function" || v === a || v === o || v === u || v === c || v === m || v === R || typeof v == "object" && v !== null && (v.$$typeof === p || v.$$typeof === b || v.$$typeof === l || v.$$typeof === f || v.$$typeof === y || v.$$typeof === T || v.$$typeof === M || v.$$typeof === k || v.$$typeof === E);
    }, e.typeOf = S;
  }();
}), bs = (O.AsyncMode, O.ConcurrentMode, O.ContextConsumer, O.ContextProvider, O.Element, O.ForwardRef, O.Fragment, O.Lazy, O.Memo, O.Portal, O.Profiler, O.StrictMode, O.Suspense, O.isAsyncMode, O.isConcurrentMode, O.isContextConsumer, O.isContextProvider, O.isElement, O.isForwardRef, O.isFragment, O.isLazy, O.isMemo, O.isPortal, O.isProfiler, O.isStrictMode, O.isSuspense, O.isValidElementType, O.typeOf, Ws(function(t) {
  process.env.NODE_ENV === "production" ? t.exports = Xr : t.exports = O;
})), en = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, ys = {};
ys[bs.ForwardRef] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, ys[bs.Memo] = en;
const tn = new Rr();
class Me {
  /**
   * Logs an info level message to New Relic.
   * @param {string} pageAction - The page action name.
   * @param {NRAttributes} data - The log data.
   */
  static info(e, s) {
    this.log("info", e, s);
  }
  /**
   * Logs an error level message to New Relic.
   * @param {string} pageAction - The page action name.
   * @param {NRErrorAttributes} data - The log data.
   */
  static error(e, s) {
    this.log("error", e, s);
  }
  static noticeError(e) {
    window != null && window.newrelic && window.newrelic.noticeError(e);
  }
  static log(e, s, r) {
    if (!window || !window.newrelic) {
      console.error("Feedback UI: New Relic not available");
      return;
    }
    window.newrelic.addPageAction(s, {
      ...r,
      logLevel: e
    });
  }
}
const Ys = Ht({
  locale: "en-us",
  origin: "DefaultOrigin",
  trackingData: void 0,
  tenant: "vistaprint",
  auth: void 0,
  getRecaptchaToken: async () => {
  }
}), Xt = () => {
  const t = Gt(Ys);
  if (!t)
    throw new Error("useFeedbackContext must be used within a FeedbackProvider");
  return t;
}, sn = ({
  children: t,
  locale: e,
  origin: s,
  trackingData: r,
  onRender: i,
  tenant: a,
  auth: c
}) => {
  const { executeRecaptcha: u } = Hr(), l = Ds(async () => {
    if (!u) {
      Me.error("Feedback UI: Recaptcha", {
        message: "Recaptcha not available",
        locale: e,
        origin: s
      });
      return;
    }
    try {
      return await u("feedbackComponentSubmit");
    } catch (f) {
      const h = f instanceof Error ? f.message : JSON.stringify(f);
      return Me.error("Feedback UI: Recaptcha", {
        message: "Failed to get recaptcha token",
        errorMessage: h,
        locale: e,
        origin: s
      }), "";
    }
  }, [u, e, s]);
  return kt(() => {
    i && i(!!u);
  }, [u, i]), /* @__PURE__ */ x(
    Ys.Provider,
    {
      value: { locale: e, origin: s, auth: c, trackingData: r, tenant: a || "vistaprint", getRecaptchaToken: l },
      children: u ? t : null
    }
  );
}, rn = "Var denne artikel nyttig?", nn = { upvote: "Ja", downvote: "Nej" }, on = "Lær, hvordan vi bruger din feedback", an = "Fortæl os, hvad der er galt, så vi kan løse det. Sæt kryds ved alle relevante.", cn = "Beskriv problemet (valgfrit)", un = "Mindst 15 tegn", ln = "Send feedback", hn = "Sender feedback ...", dn = { positive: "Tak for din feedback.", negative: "Tak for din feedback. Vi bruger den til at forbedre artiklen." }, fn = { submitError: "Der opstod et problem under lagring af din feedback. Prøv igen senere." }, pn = {
  title: rn,
  ctaButtons: nn,
  legal: on,
  selectReasons: an,
  descriptionLabel: cn,
  helperText: un,
  submitButton: ln,
  submittingFeedback: hn,
  confirmationMessages: dn,
  errorMessages: fn
}, mn = "Was this article helpful?", bn = { upvote: "Yes", downvote: "No" }, yn = "Learn how we use your feedback", vn = "Please share what's wrong so we can fix it. Select all that apply.", gn = "Describe the problem (optional)", kn = "15 characters minimum", wn = "Send feedback", Sn = "Sending feedback...", Cn = { positive: "Thanks for your feedback.", negative: "Thanks for your feedback. We’ll use it to improve the article." }, $n = { submitError: "There was an issue saving your feedback. Please try again later." }, vs = {
  title: mn,
  ctaButtons: bn,
  legal: yn,
  selectReasons: vn,
  descriptionLabel: gn,
  helperText: kn,
  submitButton: wn,
  submittingFeedback: Sn,
  confirmationMessages: Cn,
  errorMessages: $n
}, Rn = "War dieser Artikel hilfreich?", Fn = { upvote: "Ja", downvote: "Nein" }, Mn = "So verwenden wir Ihr Feedback", En = "Bitte beschreiben Sie das Problem, damit wir es beseitigen können. Wählen Sie alles Zutreffende aus.", Pn = "Beschreiben Sie das Problem (optional)", Tn = "Mindestens 15 Zeichen", On = "Feedback senden", xn = "Feedback wird gesendet …", Dn = { positive: "Vielen Dank für Ihr Feedback.", negative: "Vielen Dank für Ihr Feedback. Wir werden den Artikel entsprechend verbessern." }, An = { submitError: "Beim Speichern Ihres Feedbacks ist ein Problem aufgetreten. Bitte versuchen Sie es später noch einmal." }, Rt = {
  title: Rn,
  ctaButtons: Fn,
  legal: Mn,
  selectReasons: En,
  descriptionLabel: Pn,
  helperText: Tn,
  submitButton: On,
  submittingFeedback: xn,
  confirmationMessages: Dn,
  errorMessages: An
}, Ln = "Was this article helpful?", In = { upvote: "Yes", downvote: "No" }, Bn = "Learn how we use your feedback", qn = "Please share what's wrong so we can fix it. Select all that apply.", Nn = "Describe the problem (optional)", Qn = "15 characters minimum", _n = "Send feedback", jn = "Sending feedback...", Vn = { positive: "Thanks for your feedback.", negative: "Thanks for your feedback. We’ll use it to improve the article." }, Un = { submitError: "There was an issue saving your feedback. Please try again later." }, Te = {
  title: Ln,
  ctaButtons: In,
  legal: Bn,
  selectReasons: qn,
  descriptionLabel: Nn,
  helperText: Qn,
  submitButton: _n,
  submittingFeedback: jn,
  confirmationMessages: Vn,
  errorMessages: Un
}, zn = "¿Te ha resultado útil este artículo?", Kn = { upvote: "Sí", downvote: "No" }, Hn = "Descubre cómo usamos tus comentarios", Gn = "Indícanos que está mal para que podamos arreglarlo. Marca todas las respuestas que correspondan.", Jn = "Describe el problema (opcional)", Wn = "15 caracteres como mínimo", Yn = "Enviar comentarios", Zn = "Enviando comentarios...", Xn = { positive: "Gracias por tus comentarios.", negative: "Gracias por tus comentarios. Los usaremos para mejorar el artículo." }, ei = { submitError: "Ha habido un problema al guardar tus comentarios. Vuelve a intentarlo más tarde." }, ti = {
  title: zn,
  ctaButtons: Kn,
  legal: Hn,
  selectReasons: Gn,
  descriptionLabel: Jn,
  helperText: Wn,
  submitButton: Yn,
  submittingFeedback: Zn,
  confirmationMessages: Xn,
  errorMessages: ei
}, si = "¿Le resultó útil este artículo?", ri = { upvote: "Sí", downvote: "No" }, ni = "Sepa cómo utilizamos sus comentarios", ii = "Por favor, comparta lo que está mal para que podamos solucionarlo. Seleccione todas las opciones que correspondan.", oi = "Describa el problema (opcional)", ai = "15 caracteres como mínimo", ci = "Enviar comentarios", ui = "Enviando comentarios...", li = { positive: "Gracias por sus comentarios.", negative: "Gracias por sus comentarios. Los utilizaremos para mejorar el artículo." }, hi = { submitError: "Hubo un problema al guardar sus comentarios. Vuelva a intentarlo más tarde." }, di = {
  title: si,
  ctaButtons: ri,
  legal: ni,
  selectReasons: ii,
  descriptionLabel: oi,
  helperText: ai,
  submitButton: ci,
  submittingFeedback: ui,
  confirmationMessages: li,
  errorMessages: hi
}, fi = "Oliko tästä artikkelista hyötyä?", pi = { upvote: "Kyllä", downvote: "Ei" }, mi = "Lue tästä, miten käytämme palautettasi", bi = "Kerro, mikä on vialla voidaksemme korjata asian. Valitse kaikki sopivat vaihtoehdot.", yi = "Kuvaile ongelmaa (valinnainen)", vi = "Vähintään 15 merkkiä", gi = "Lähetä palautetta", ki = "Lähettää palautetta...", wi = { positive: "Kiitos palautteestasi.", negative: "Kiitos palautteestasi. Parannamme artikkelia sen avulla." }, Si = { submitError: "Palautteen tallentamisessa oli ongelmia. Yritä myöhemmin uudelleen." }, Ci = {
  title: fi,
  ctaButtons: pi,
  legal: mi,
  selectReasons: bi,
  descriptionLabel: yi,
  helperText: vi,
  submitButton: gi,
  submittingFeedback: ki,
  confirmationMessages: wi,
  errorMessages: Si
}, $i = "Cet article vous a-t-il aidé ?", Ri = { upvote: "Oui", downvote: "Non" }, Fi = "Découvrez comment nous utilisons vos commentaires", Mi = "Merci de nous indiquer le problème afin que nous puissions le résoudre. Sélectionnez toutes les réponses applicables.", Ei = "Décrivez le problème (facultatif)", Pi = "15 caractères minimum", Ti = "Envoyer vos commentaires", Oi = "Envoi en cours...", xi = { positive: "Merci de nous avoir fait part de vos commentaires.", negative: "Merci de nous avoir fait part de vos commentaires. Nous les utiliserons pour améliorer cet article." }, Di = { submitError: "Malheureusement, une erreur est survenue lors de l’enregistrement de vos commentaires. Merci de réessayer ultérieurement." }, Ft = {
  title: $i,
  ctaButtons: Ri,
  legal: Fi,
  selectReasons: Mi,
  descriptionLabel: Ei,
  helperText: Pi,
  submitButton: Ti,
  submittingFeedback: Oi,
  confirmationMessages: xi,
  errorMessages: Di
}, Ai = "Cet article vous a-t-il été utile?", Li = { upvote: "Oui", downvote: "Non" }, Ii = "Découvrez comment nous utilisons vos commentaires", Bi = "Veuillez nous indiquer ce qui ne va pas afin que nous puissions le corriger. Sélectionnez toutes les réponses pertinentes.", qi = "Décrivez le problème (facultatif)", Ni = "15 caractères minimum", Qi = "Envoyez vos commentaires", _i = "Envoi des commentaires...", ji = { positive: "Merci de nous avoir fait part de vos commentaires.", negative: "Merci de nous avoir fait part de vos commentaires. Ils nous permettront d’améliorer l’article." }, Vi = { submitError: "Un problème est survenu lors de l’enregistrement de vos commentaires. Veuillez réessayer ultérieurement." }, Ui = {
  title: Ai,
  ctaButtons: Li,
  legal: Ii,
  selectReasons: Bi,
  descriptionLabel: qi,
  helperText: Ni,
  submitButton: Qi,
  submittingFeedback: _i,
  confirmationMessages: ji,
  errorMessages: Vi
}, zi = "Hai trovato utile questo articolo?", Ki = { upvote: "Sì", downvote: "No" }, Hi = "La tua opinione è importante", Gi = "Indicaci il problema affinché possiamo risolverlo. Seleziona tutte le opzioni pertinenti.", Ji = "Descrivi il problema (facoltativo)", Wi = "Minimo 15 caratteri", Yi = "Invia feedback", Zi = "Invio feedback in corso...", Xi = { positive: "Grazie per il feedback.", negative: "Grazie per il feedback. Lo utilizzeremo per migliorare l’articolo." }, eo = { submitError: "Non è stato possibile salvare il feedback. Riprova più tardi." }, gs = {
  title: zi,
  ctaButtons: Ki,
  legal: Hi,
  selectReasons: Gi,
  descriptionLabel: Ji,
  helperText: Wi,
  submitButton: Yi,
  submittingFeedback: Zi,
  confirmationMessages: Xi,
  errorMessages: eo
}, to = "Var denne artikkelen nyttig?", so = { upvote: "Ja", downvote: "Nei" }, ro = "Finn ut mer om hvordan vi bruker tilbakemeldingene", no = "Fortell oss hva som er feil, så skal vi rette opp i det. Du kan krysse av for flere alternativer.", io = "Beskriv problemet (valgfritt)", oo = "Minst 15 tegn", ao = "Send tilbakemelding", co = "Sender tilbakemelding …", uo = { positive: "Takk for tilbakemeldingen.", negative: "Takk for tilbakemeldingen. Vi bruker informasjonen til å forbedre denne artikkelen." }, lo = { submitError: "Det oppsto et problem under lagringen av tilbakemeldingen. Prøv igjen senere." }, ho = {
  title: to,
  ctaButtons: so,
  legal: ro,
  selectReasons: no,
  descriptionLabel: io,
  helperText: oo,
  submitButton: ao,
  submittingFeedback: co,
  confirmationMessages: uo,
  errorMessages: lo
}, fo = "Was dit artikel nuttig?", po = { upvote: "Ja", downvote: "Nee" }, mo = "Ontdek hoe we je feedback gebruiken", bo = "Vertel ons wat er niet goed is, dan kunnen we het oplossen. Meerdere antwoorden mogelijk.", yo = "Beschrijf het probleem (optioneel)", vo = "Minimaal 15 tekens", go = "Feedback versturen", ko = "Feedback wordt verstuurd...", wo = { positive: "Bedankt voor je feedback.", negative: "Bedankt voor je feedback. Die gebruiken we om het artikel te verbeteren." }, So = { submitError: "Er was een probleem bij het versturen van je feedback. Probeer het later opnieuw." }, ks = {
  title: fo,
  ctaButtons: po,
  legal: mo,
  selectReasons: bo,
  descriptionLabel: yo,
  helperText: vo,
  submitButton: go,
  submittingFeedback: ko,
  confirmationMessages: wo,
  errorMessages: So
}, Co = "Achou este artigo útil?", $o = { upvote: "Sim", downvote: "Não" }, Ro = "Saiba como utilizamos o seu feedback", Fo = "Diga-nos o que se passa, para que possamos corrigir. Selecione todas as opções aplicáveis.", Mo = "Descreva o problema (opcional)", Eo = "15 carateres no mínimo", Po = "Enviar feedback", To = "A enviar feedback...", Oo = { positive: "Recebemos o seu feedback.", negative: "Recebemos o seu feedback. Vamos utilizá-lo para melhorar o artigo." }, xo = { submitError: "Ocorreu um problema ao guardar o seu feedback. Tente novamente mais tarde." }, Do = {
  title: Co,
  ctaButtons: $o,
  legal: Ro,
  selectReasons: Fo,
  descriptionLabel: Mo,
  helperText: Eo,
  submitButton: Po,
  submittingFeedback: To,
  confirmationMessages: Oo,
  errorMessages: xo
}, Ao = "Var den här artikeln till hjälp?", Lo = { upvote: "Ja", downvote: "Nej" }, Io = "Läs mer om hur vi använder din feedback", Bo = "Dela med dig av vad som är fel så att vi kan åtgärda det. Markera allt som stämmer in.", qo = "Beskriv problemet (valfritt)", No = "Minst 15 tecken", Qo = "Skicka feedback", _o = "Skickar feedback...", jo = { positive: "Tack för din feedback.", negative: "Tack för din feedback. Vi kommer att använda den för att förbättra artikeln." }, Vo = { submitError: "Ett fel uppstod när din feedback skulle sparas. Försök igen senare." }, Uo = {
  title: Ao,
  ctaButtons: Lo,
  legal: Io,
  selectReasons: Bo,
  descriptionLabel: qo,
  helperText: No,
  submitButton: Qo,
  submittingFeedback: _o,
  confirmationMessages: jo,
  errorMessages: Vo
}, zo = {
  da_dk: {
    vistaprint: pn
  },
  en_us: {
    vistaprint: vs
  },
  en_ca: {
    vistaprint: vs
  },
  de_de: {
    vistaprint: Rt
  },
  de_ch: {
    vistaprint: Rt
  },
  de_at: {
    vistaprint: Rt
  },
  en_au: {
    vistaprint: Te
  },
  en_gb: {
    vistaprint: Te
  },
  en_ie: {
    vistaprint: Te
  },
  en_in: {
    vistaprint: Te
  },
  en_nz: {
    vistaprint: Te
  },
  en_sg: {
    vistaprint: Te
  },
  es_es: {
    vistaprint: ti
  },
  es_us: {
    vistaprint: di
  },
  fi_fi: {
    vistaprint: Ci
  },
  fr_be: {
    vistaprint: Ft
  },
  fr_ca: {
    vistaprint: Ui
  },
  fr_ch: {
    vistaprint: Ft
  },
  fr_fr: {
    vistaprint: Ft
  },
  it_ch: {
    vistaprint: gs
  },
  it_it: {
    vistaprint: gs
  },
  nb_no: {
    vistaprint: ho
  },
  nl_be: {
    vistaprint: ks
  },
  nl_nl: {
    vistaprint: ks
  },
  pt_pt: {
    vistaprint: Do
  },
  sv_se: {
    vistaprint: Uo
  }
}, Zs = Ht({
  locale: "en-us",
  t: () => ""
}), es = () => {
  const t = Gt(Zs);
  if (!t)
    throw new Error("useTranslations must be used within a TranslationsProvider");
  return t;
}, Ko = ({ children: t, locale: e, tenant: s }) => {
  var c, u;
  const r = (u = (c = e || "en-us") == null ? void 0 : c.toLowerCase()) == null ? void 0 : u.replace("-", "_"), i = (l, f) => f.split(".").reduce((h, o) => h ? h[o] : f, l), a = (l) => l ? i(zo[r][s], l) || l : "";
  return /* @__PURE__ */ x(Zs.Provider, { value: { locale: e, t: a }, children: t });
}, Ho = (t) => {
  const { locale: e, tenant: s } = Xt();
  return jr({
    queryKey: ["reasons"],
    queryFn: async () => {
      if (t) return t;
      const i = await fetch(
        `https://help-center-service.care.vpsvc.com/feedback/reasons/${s}/${e}/list`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
      if (!i.ok)
        throw Me.error("Feedback UI: Reasons", { status: i.status, message: "Failed to fetch reasons" }), new Error(`HTTP error! Status: ${i.status}`);
      const a = await i.json();
      return a == null ? void 0 : a.reasons;
    },
    staleTime: 1 / 0,
    gcTime: 1 / 0
  });
}, Xs = () => {
  const { locale: t, trackingData: e } = Xt(), [s, r] = t.split("-");
  return Js({
    mutationKey: ["trackEvent"],
    mutationFn: async (a) => {
      var f, h;
      const { actionName: c, details: u } = a;
      await new Promise((o) => {
        let y = 0;
        const m = setInterval(() => {
          var R;
          if ((R = window == null ? void 0 : window.tracking) != null && R.track) {
            clearInterval(m), o();
            return;
          }
          y += 100, y >= 1e3 && (console.error("Tracking not available"), Me.error("Feedback UI: Tracking", { message: "Tracking not available", locale: t, origin }), clearInterval(m), o());
        }, 100);
      }), (f = window == null ? void 0 : window.tracking) != null && f.track && ((h = window == null ? void 0 : window.tracking) == null || h.track(c || "Feedback Component Engaged", {
        language: s,
        locale: r,
        ...u,
        ...e
      }));
    }
  });
}, Go = (t) => (t == null ? void 0 : t.articleNumber) !== void 0, Jo = (t) => {
  const { locale: e, getRecaptchaToken: s, auth: r, trackingData: i, origin: a } = Xt(), { mutateAsync: c } = Xs(), u = (h, o) => {
    const y = h instanceof Error ? h.message : JSON.stringify(h);
    Me.error("Feedback UI: Vote", { type: o, message: "Failed to submit vote", errorMessage: y, locale: e, origin: a }), c({ actionName: "Error Message Displayed", details: { label: "Issue Saving Feedback", ...i } });
  }, l = async (h) => {
    try {
      if (!r) throw new Error("Auth not found");
      const o = r.getAuthorizationHeader(), y = await s();
      if (!y) throw new Error("Recaptcha token not found");
      const { feedbackReasons: m, ...R } = h, b = await fetch(
        `https://help-center-service.care.vpsvc.com/feedback/${e}/articles/${R.articleId}/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-recap-token": y,
            Authorization: o
          },
          body: JSON.stringify({
            ...R,
            feedbackReason: m == null ? void 0 : m.join(";")
          })
        }
      );
      if (!b.ok)
        throw new Error(`HTTP error! Status: ${b.status}`);
      return Me.info("Feedback UI: Vote", {
        type: "Article Vote Submitted",
        articleId: R.articleNumber,
        locale: e,
        origin: a,
        vote: h.upvote ? "upVote" : "downVote",
        feedbackReasons: m == null ? void 0 : m.join(";")
      }), !0;
    } catch (o) {
      throw u(o, "Article Vote"), o;
    }
  };
  return Js({
    mutationKey: ["articleVote"],
    mutationFn: async (h) => {
      try {
        if (t) {
          const o = await t(h);
          if (!o.success) throw new Error(o.error || "Failed to submit custom vote");
          return Me.info("Feedback UI: Vote", {
            type: "Custom Vote Submitted",
            vote: h.upvote ? "upVote" : "downVote",
            locale: e,
            origin: a
          }), o.success;
        }
      } catch (o) {
        throw u(o, "Vote"), o;
      }
      if (!Go(h)) throw new Error("Invalid vote type");
      return l(h);
    }
  });
}, Wo = (t) => {
  const { t: e } = es(), [s, r] = ye({}), [i, a] = ye(""), [c, u] = ye(!1), l = xs(null), { reasons: f, submitVote: h } = t, o = Object.keys(s).filter((k) => s[k]), y = f == null ? void 0 : f.some((k) => k.requiredDescription && o.includes(k.default)), m = c || !(o != null && o.length) || y && !i, [R, b] = ye(!1), p = y || R || i.trim().length > 0, E = f == null ? void 0 : f.map((k, S) => /* @__PURE__ */ x(nr, { value: k.default, children: /* @__PURE__ */ x(ir, { children: k.localized }) }, S));
  kt(() => {
    y && l.current && l.current.focus();
  }, [y]);
  const T = async () => {
    u(!0);
    try {
      await h({ feedbackReasons: o, feedbackDescription: i });
    } catch (k) {
      console.error("Error submitting feedback", k);
    } finally {
      u(!1);
    }
  }, M = (k) => {
    var I;
    if (((I = k.target.value) == null ? void 0 : I.trim()) && !y && !o.length) {
      const D = { ...s }, C = f == null ? void 0 : f.filter((w) => w.requiredDescription);
      C == null || C.forEach((w) => {
        D[w.default] = !0;
      }), r(D);
    }
    a(k.target.value);
  };
  return /* @__PURE__ */ ve(mt, { flexDirection: "column", gap: "6", pt: "8", children: [
    /* @__PURE__ */ ve(He, { fontSkin: "title-item", children: [
      e("selectReasons"),
      " "
    ] }),
    /* @__PURE__ */ x(
      or,
      {
        variant: "multi-select",
        skin: "simple-column",
        selectedValues: s,
        onSelectedValuesChange: (k) => r(k),
        children: E
      }
    ),
    /* @__PURE__ */ ve(mt, { flexDirection: "column", children: [
      /* @__PURE__ */ x(
        ar,
        {
          value: i,
          onChange: M,
          placeholder: e("descriptionLabel"),
          rows: 4,
          maxLength: 1e3,
          fullWidth: !0,
          style: { maxWidth: 400 },
          resize: "vertical",
          ref: l,
          onFocus: () => b(!0),
          onBlur: () => b(!1)
        }
      ),
      p && /* @__PURE__ */ x(He, { fontSkin: "body-small", textColor: "subtle", children: e("helperText") })
    ] }),
    /* @__PURE__ */ x(cr, { children: /* @__PURE__ */ ve(
      As,
      {
        disabled: m || (i == null ? void 0 : i.trim().length) > 0 && (i == null ? void 0 : i.trim().length) < 15,
        onClick: T,
        children: [
          c && /* @__PURE__ */ x(Ls, { size: "tiny", accessibleText: e("submittingFeedback") }),
          e(c ? "submittingFeedback" : "submitButton")
        ]
      }
    ) })
  ] });
}, Yo = "_active_17kby_1", Zo = {
  active: Yo
}, ws = ({ voteType: t, isActive: e, isSubmitting: s, onClick: r }) => {
  const { t: i } = es(), a = s && e, c = t === "upVote" ? "like" : "dislike", u = t === "upVote" ? "ctaButtons.upvote" : "ctaButtons.downvote";
  return /* @__PURE__ */ ve(
    As,
    {
      className: e ? Zo.active : "",
      skin: "secondary",
      iconPosition: "left",
      disabled: a,
      onClick: () => !e && r(),
      children: [
        a && /* @__PURE__ */ x(Ls, { size: "tiny", accessibleText: i("submittingFeedback") }),
        i(u),
        (!s || !e) && /* @__PURE__ */ x(ur, { iconType: c })
      ]
    }
  );
}, Xo = ({ onUpVote: t, onDownVote: e, previousVote: s, isSubmitting: r }) => /* @__PURE__ */ ve(mt, { flexDirection: "row", gap: "4", py: "6", children: [
  /* @__PURE__ */ x(
    ws,
    {
      voteType: "upVote",
      isActive: s === "upVote",
      isSubmitting: r,
      onClick: t
    }
  ),
  /* @__PURE__ */ x(
    ws,
    {
      voteType: "downVote",
      isActive: s === "downVote",
      isSubmitting: r,
      onClick: e
    }
  )
] }), ea = (t) => {
  var D;
  const { t: e } = es(), { title: s, onFeedbackSubmit: r, previousVote: i, articleData: a, feedbackReasons: c } = t, { mutateAsync: u, isPending: l, reset: f } = Jo(r), { data: h } = Ho(c), { mutateAsync: o } = Xs(), [y, m] = ye(!1), [R, b] = ye(!1), [p, E] = ye(), T = !!p && !!(h != null && h[p]) && ((D = h == null ? void 0 : h[p]) == null ? void 0 : D.length) > 0, M = l && p && !T, k = async (C) => {
    var Q;
    if (p === C) return;
    E(C);
    const w = !!(h != null && h[C]) && ((Q = h == null ? void 0 : h[C]) == null ? void 0 : Q.length) > 0;
    await S(C === "upVote", void 0, !w);
  }, S = async (C, w, Q) => {
    var Xe, et;
    f(), b(!1), m(!1);
    const G = (w == null ? void 0 : w.feedbackReasons) && ((Xe = w == null ? void 0 : w.feedbackReasons) == null ? void 0 : Xe.length) > 0, oe = C ? `Positive Feedback${G ? ":Feedback Sent" : ""}` : `Negative Feedback${G ? ":Feedback Sent" : ""}`, wt = ((et = w == null ? void 0 : w.feedbackReasons) == null ? void 0 : et.join("_")) || void 0;
    o({
      details: {
        label: oe,
        eventDetail: wt
      }
    });
    try {
      if (!await u({ upvote: C, ...a, ...w })) {
        console.info("Error submitting vote"), b(Q || !1);
        return;
      }
    } catch (tt) {
      console.error("Error submitting vote", tt), b(Q || !1);
      return;
    }
    m(Q || !1);
  }, I = () => {
    const C = typeof window < "u" ? window == null ? void 0 : window.location.pathname : "";
    o({
      actionName: "Navigation Clicked",
      details: {
        label: "Content:Feedback Component",
        eventDetail: `${C};/vista-privacy-and-cookie-notice#what-personal-information;Content:Feedback Component;Learn how we use your feedback`,
        navigationDetail: "Learn how we use your feedback"
      }
    });
  };
  return kt(() => {
    o({ actionName: "Feedback Component Viewed" });
  }, []), /* @__PURE__ */ ve(mt, { flexDirection: "column", children: [
    /* @__PURE__ */ x(He, { fontSkin: "title-subsection", children: s || e("title") }),
    /* @__PURE__ */ x(
      Xo,
      {
        isSubmitting: M,
        onUpVote: () => k("upVote"),
        onDownVote: () => k("downVote"),
        previousVote: p || i
      }
    ),
    /* @__PURE__ */ x(lr, { target: "_blank", onClick: I, href: "/vista-privacy-and-cookie-notice#what-personal-information", children: e("legal") }),
    T && !y && /* @__PURE__ */ x(
      Wo,
      {
        reasons: h[p] || [],
        submitVote: (C) => S(p === "upVote", C, !0)
      }
    ),
    R && /* @__PURE__ */ x(He, { pt: "8", fontSkin: "title-item", textColor: "error", children: e("errorMessages.submitError") }),
    y && /* @__PURE__ */ x(He, { pt: "8", fontSkin: "title-item", children: e(p === "downVote" ? "confirmationMessages.negative" : "confirmationMessages.positive") })
  ] });
}, ia = (t) => /* @__PURE__ */ x(Ko, { locale: t.locale, tenant: t.tenant || "vistaprint", children: /* @__PURE__ */ x(Tr, { client: tn, children: /* @__PURE__ */ x(Kr, { reCaptchaKey: "6LcTQGQjAAAAAPi6TjZ2Lql9__mY9JV7IcX6140Q", useEnterprise: !0, children: /* @__PURE__ */ x(sn, { ...t, children: /* @__PURE__ */ x(ea, { ...t }) }) }) }) });
export {
  ia as FeedbackComponent,
  Go as isArticleVote
};
//# sourceMappingURL=feedback-ui.js.map
